export const FETCH_FEATURE_FLAGS_SUCCESS = 'hall/featureFlags/FETCH_SUCCESS'
export const FETCH_FEATURE_FLAGS_ERROR = 'hall/featureFlags/FETCH_ERROR'
export const CLEAR_FEATURE_FLAGS = 'hall/featureFlags/CLEAR'

// localStorage key the last successful fetch is persisted under, so a page
// reload boots with the last known flags instead of an empty store.
export const STORAGE_KEY = 'hall/featureFlags/CACHE'
